import AbstractSessionModel from './AbstractSessionModel';
import Observable from '../decorators/Observable';
import Action from '../decorators/Action';
import StoreFieldInSession from '../decorators/StoreFieldInSession';

class HelpBoxCompanionModel extends AbstractSessionModel {
  constructor() {
    super();
    super.initFields()
  }
  @Observable()
  helpBoxTitleMessage: string = "";

  @Observable()
  helpBoxParagraphMessage: string = "";

  @Observable()
  displayHelpBox: boolean = true;

  @Action()
  setTitleMessage(message: string) : void {
    this.helpBoxTitleMessage = message;
 }

  @Action()
  setParagraphMessage(message: string) : void {
    this.helpBoxParagraphMessage = message;
 }
    
  getSessionKey(): string {
    return 'helpBoxtextMessage';
  }

  @Action()
  setDisplayHelpBox(display: boolean) {
    this.displayHelpBox = display;
  } 
}

export default new HelpBoxCompanionModel;